import { render, staticRenderFns } from "./QuickListModal.vue?vue&type=template&id=b5f96440&scoped=true"
import script from "./QuickListModal.vue?vue&type=script&lang=ts"
export * from "./QuickListModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f96440",
  null
  
)

export default component.exports